import React from 'react'
import homeImg from 'assets/images/home1.png';
import HighlightCard from 'components/HighlightCard';

export default function Home(props: any) {
    return (
        <div className="page">
            <div className="d-flex align-items-center">
                <div className="home-container">
                    <div>
                        <div className='info-card'>
                            <HighlightCard />
                        </div>
                        <img src={homeImg} />
                    </div>
                </div>
            </div>
        </div>
    )

}
